import { createTheme, rem } from '@mantine/core'

/**
 * Dense by default. An ERP screen shows a lot at once, and Mantine's stock
 * spacing is tuned for marketing pages rather than for a table of 200 rows.
 */
export const theme = createTheme({
  primaryColor: 'indigo',
  /*
   * Two palettes Mantine does not ship, so board columns have more than the
   * stock thirteen to choose from.
   *
   * Full ten-shade scales rather than a single value, because every use here
   * asks for a specific step - `-6` for a ring, `-light` for a wash - and a
   * short array leaves those resolving to nothing, which fails silently as a
   * transparent column.
   *
   * Kept in step with `Project::COLOURS` on the server, which is the list
   * that actually decides: a colour offered here and missing there is quietly
   * dropped on save.
   */
  colors: {
    brown: [
      '#faf3ef', '#ece1da', '#d8c1b3', '#c5a089', '#b48466',
      '#ab724f', '#a76a43', '#925935', '#824e2d', '#714122',
    ],
    slate: [
      '#f2f5f9', '#e4e8ed', '#c6ced9', '#a5b3c5', '#899cb4',
      '#778eaa', '#6d86a6', '#5c7391', '#506782', '#425a74',
    ],
  },
  defaultRadius: 'md',
  /*
   * Inter, self-hosted from npm rather than fetched from Google: no request
   * to a third party on every page, and it is cached with the bundle. The
   * system stack behind it is only for the moment before the file arrives.
   */
  fontFamily:
    '"Inter Variable", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
  headings: {
    fontWeight: '600',
    sizes: {
      h1: { fontSize: rem(26), lineHeight: '1.3' },
      h2: { fontSize: rem(20), lineHeight: '1.35' },
      h3: { fontSize: rem(16), lineHeight: '1.4' },
    },
  },
  components: {
    Card: { defaultProps: { padding: 'md', withBorder: true } },
    Paper: { defaultProps: { withBorder: true } },
    Button: { defaultProps: { size: 'sm' } },
    // The active item is a filled block, so it needs the same rounding as
    // every other surface - square corners against a rounded shell read as
    // an unstyled default.
    NavLink: {
      styles: {
        root: {
          borderRadius: 'var(--mantine-radius-md)',
        },
      },
    },
    // Square, whatever the default radius is. At 16px a "md" corner is half
    // the box, so a small checkbox came out perfectly round and read as a
    // radio - which matters most where the two sit in one panel, as they do
    // in the board filters.
    Checkbox: { defaultProps: { radius: 'sm' } },
    TextInput: { defaultProps: { size: 'sm' } },
    PasswordInput: { defaultProps: { size: 'sm' } },
  },
})
